// Reads a one-time token from the URL fragment (preferred: never sent to servers/logs) or query string,
// then scrubs it from the address bar + history so it cannot leak via history, bookmarks or Referer.
export function takeUrlToken() {
  const hash = new URLSearchParams(window.location.hash.replace(/^#/, ""));
  const query = new URLSearchParams(window.location.search);
  const token = hash.get("token") || query.get("token") || "";
  if (token) window.history.replaceState(null, "", window.location.pathname);
  return token;
}
